module.exports = __webpack_public_path__ + "img/mocLogo.e9249e91.png";